export default {
  dailyDashboard: 'Daily Dashboard',
  fillRateOverview: 'Wonoloer Fill Rate Overview',
  upcomingWeek: "Upcoming Week's Outlook",
  fillRate: 'fill rate',
  noActiveJobs: 'No Active Jobs',
  actionItems: 'Action Items',
  completeNow: 'Complete Now',
  repostRecentJobs: 'Repost Recent Jobs',
  viewAllRepostableJobs: 'View All Repostable Jobs',
  hourly: 'Hourly',
  wonoloer: 'Wonoloer',
  repost: 'Repost',
  help: 'Help'
};
